var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":"/admin/dashboard"}},[_vm._v("Admin dashboard")])])
}]

export { render, staticRenderFns }